export default {
  // url: process.env.MANAGER_API_BASE_URL
  url: "/api",
};
